/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthClientUIConfiguration
 */
export interface OAuthClientUIConfiguration {
    [key: string]: any | any;
    /**
     * Configuration for dynamic flow
     * @type {{ [key: string]: any; }}
     * @memberof OAuthClientUIConfiguration
     */
    dynamicFlowConfig?: { [key: string]: any; };
    /**
     * Whether dynamic flow is enabled
     * @type {boolean}
     * @memberof OAuthClientUIConfiguration
     */
    dynamicFlowEnabled?: boolean;
    /**
     * The types of handles that can be used to authenticate
     * @type {Array<string>}
     * @memberof OAuthClientUIConfiguration
     */
    handleTypes?: Array<string>;
    /**
     * The URL of the logo to display in the login form
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    logoUrl?: string;
    /**
     * The background color of the page
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    pageBackgroundColor?: string;
    /**
     * Whether to show the SlashID badge
     * @type {boolean}
     * @memberof OAuthClientUIConfiguration
     */
    showBadge?: boolean;
    /**
     * Whether to store the last factor used for authentication
     * @type {boolean}
     * @memberof OAuthClientUIConfiguration
     */
    storeLastFactor?: boolean;
    /**
     * If set, the support link will be displayed in the error state
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    supportURL?: string;
    /**
     * If set, the alternative auth link will be displayed in the self-registration-not-allowed error state
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    alternativeAuthURL?: string;
    /**
     * The URL of the favicon to display in the browser tab
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    faviconUrl?: string;
    /**
     * The title of the page
     * @type {string}
     * @memberof OAuthClientUIConfiguration
     */
    pageTitle?: string;
    /**
     * The SlashID theme CSS variables
     * @type {{ [key: string]: string; }}
     * @memberof OAuthClientUIConfiguration
     */
    themeVars?: { [key: string]: string; };
    /**
     * Text keys and overriden values
     * @type {{ [key: string]: string; }}
     * @memberof OAuthClientUIConfiguration
     */
    textOverrides?: { [key: string]: string; };
}

/**
 * Check if a given object implements the OAuthClientUIConfiguration interface.
 */
export function instanceOfOAuthClientUIConfiguration(value: object): value is OAuthClientUIConfiguration {
    return true;
}

export function OAuthClientUIConfigurationFromJSON(json: any): OAuthClientUIConfiguration {
    return OAuthClientUIConfigurationFromJSONTyped(json, false);
}

export function OAuthClientUIConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthClientUIConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'dynamicFlowConfig': json['dynamicFlowConfig'] == null ? undefined : json['dynamicFlowConfig'],
        'dynamicFlowEnabled': json['dynamicFlowEnabled'] == null ? undefined : json['dynamicFlowEnabled'],
        'handleTypes': json['handleTypes'] == null ? undefined : json['handleTypes'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'pageBackgroundColor': json['pageBackgroundColor'] == null ? undefined : json['pageBackgroundColor'],
        'showBadge': json['showBadge'] == null ? undefined : json['showBadge'],
        'storeLastFactor': json['storeLastFactor'] == null ? undefined : json['storeLastFactor'],
        'supportURL': json['supportURL'] == null ? undefined : json['supportURL'],
        'alternativeAuthURL': json['alternativeAuthURL'] == null ? undefined : json['alternativeAuthURL'],
        'faviconUrl': json['faviconUrl'] == null ? undefined : json['faviconUrl'],
        'pageTitle': json['pageTitle'] == null ? undefined : json['pageTitle'],
        'themeVars': json['themeVars'] == null ? undefined : json['themeVars'],
        'textOverrides': json['textOverrides'] == null ? undefined : json['textOverrides'],
    };
}

export function OAuthClientUIConfigurationToJSON(json: any): OAuthClientUIConfiguration {
    return OAuthClientUIConfigurationToJSONTyped(json, false);
}

export function OAuthClientUIConfigurationToJSONTyped(value?: OAuthClientUIConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'dynamicFlowConfig': value['dynamicFlowConfig'],
        'dynamicFlowEnabled': value['dynamicFlowEnabled'],
        'handleTypes': value['handleTypes'],
        'logoUrl': value['logoUrl'],
        'pageBackgroundColor': value['pageBackgroundColor'],
        'showBadge': value['showBadge'],
        'storeLastFactor': value['storeLastFactor'],
        'supportURL': value['supportURL'],
        'alternativeAuthURL': value['alternativeAuthURL'],
        'faviconUrl': value['faviconUrl'],
        'pageTitle': value['pageTitle'],
        'themeVars': value['themeVars'],
        'textOverrides': value['textOverrides'],
    };
}

